
import Vue from "vue";
import { IFrequencyObject } from "@/utils/frequency-object";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IFrequencyObject,
			required: true
		},
		xs: {
			type: [String,Number],
			default: "12"
		},
		md: {
			type: [String, Number],
			default: "6"
		}
	},
	computed: {
		inputValue():number {
			return parseInt(this.value.FrequencyMoment) || 1;
		}
	},
	watch: {
		"state.doc.FrequencyMoment": {
			immediate: true,
			handler(){
				let val = parseInt(this.value.FrequencyMoment);
				if (Number.isNaN(val)){
					this.setValue(1);
				}else if (val < 1) {
					this.setValue(1);
				}else if (val > 31) {
					this.setValue(31);
				}
			},
		}
	},
	methods: {
		setValue(val:number) {
			this.value.FrequencyMoment = `${val}`;
		}
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
